<script setup>
import OptionValue from "@/components/ui/OptionValue.vue";
import dayjs from "dayjs";

const { slots } = defineProps({
  slots: {
    type: Array,
    required: true,
  },
  selectedSlot: {
    type: Object,
  },
  disabled: {
    type: Boolean,
    required: true,
  },
});

const emit = defineEmits([
  'slot-change'
]);
const onSlotChange = (slot) => {
  emit('slot-change', slot);
};

</script>

<template>
  <OptionValue v-for="slot in slots"
               :key="slot.id"
               :option-value="slot.id"
               @change="onSlotChange(slot)"
               class="mb-2"
               :selected="selectedSlot?.start_at === slot.start_at && selectedSlot?.end_at === slot.end_at"
               :disabled="disabled || slot.availableEquipments.length === 0"
  >
    {{ dayjs(slot.start_at).format('LT') }}
    →
    {{ dayjs(slot.end_at).format('LT') }}
  </OptionValue>
</template>

<style scoped>

</style>